export interface GuiaCandidate {
  scope: string;
  organization_id: string | null;
}

export function pickWorkspaceGuia<T extends GuiaCandidate>(
  list: readonly T[] | null | undefined,
  activeWorkspaceId: string | null | undefined,
): T | null {
  if (!activeWorkspaceId || !list) return null;
  return list.find((a) => a.scope === "campaign" && a.organization_id === activeWorkspaceId) ?? null;
}
